import S_base from '@/service/api/v1/__base';

export default {
  async show(llBroadcastId, params) {
    const res = await S_base.show({
      modelName: 'll_broadcast',
      modelId: llBroadcastId,
      params: params,
    });
    return res;
  },
  async index(params) {
    const _params = {
      order_by: "announce_at",
      order_way: "desc",
      ...params,
    }
    const res = await S_base.index({
      modelName: 'll_broadcast',
      params: _params,
      pagination: true,
    });
    return res;
  },
};
